import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IIndividualsVehicles } from 'src/app/modules/interfaces/vehicles.interface';

export interface IIndividualVehicleState {
  check: boolean;
  model: string;
  yearOfPurchase: number;
  estimatedValue: number;
}

@Component({
  selector: 'app-vehicle-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
})
export class FormsVehicleComponent implements OnInit {
  @Input() data: IIndividualsVehicles;
  @Output() value: EventEmitter<IIndividualsVehicles> =
    new EventEmitter<IIndividualsVehicles>();

  constructor() {}

  ngOnInit(): void {
    this.dataLocal = { ...this.data };
  }

  dataLocal: IIndividualsVehicles;

  modelKey = this.getKey();
  yearOfPurchaseKey = this.getKey();
  estimatedValueKey = this.getKey();

  getKey(): string {
    return 'componente_' + Math.random().toString(36).substring(7);
  }

  updateDataValue(value, property: string): void {
    this.dataLocal = {
      ...this.dataLocal,
      [property]: value,
    };
    this.value.emit(this.dataLocal);
  }
}
